/**
 * Theme palette exports
 * Centralized export for all color palettes
 */

import { classicLight, classicDark } from './palette-classic';
import { heritageLight, heritageDark } from './palette-heritage';
import { mediterraneanLight, mediterraneanDark } from './palette-mediterranean';
import { minimalistLight, minimalistDark } from './palette-minimalist';
import { ThemeColors } from '../../assets/theme';

export type PaletteName =
  | 'classic'
  | 'heritage'
  | 'mediterranean'
  | 'minimalist';

export const palettes = {
  classic: {
    light: classicLight,
    dark: classicDark,
  },
  heritage: {
    light: heritageLight,
    dark: heritageDark,
  },
  mediterranean: {
    light: mediterraneanLight,
    dark: mediterraneanDark,
  },
  minimalist: {
    light: minimalistLight,
    dark: minimalistDark,
  },
} as const;

export const getPaletteColors = (
  palette: PaletteName,
  mode: 'light' | 'dark'
): ThemeColors => {
  return palettes[palette][mode];
};
